import React, { useState, useEffect } from 'react'
import CustomAlert from '../../components/shared/CustomAlert'
import { observer } from 'mobx-react-lite'
import { withRouter } from 'react-router-dom'
import DashboardLayout from '../../components/Admin/DashboardLayout'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBRadio, MDBIcon } from 'mdb-react-ui-kit'
import MDB4Switch from '../../components/forms/MDB4Switch'
import { toast } from 'react-toastify'
import AdminApi from '../../api/admin-api/admin-api'
import TextEditor from '../../components/shared/TextEditor/TextEditor.component'
import MessageEditor from './../../components/messaging/MessageEditor/MessageEditor.component'
import { MessagesList, MessageForm, Store } from './../../components/messaging'
import getQueryParams from '../../shared/utilities/getQueryParams.function'

import './MessagingEditor.component.scss'

const getUrlCategory = () => {
  if (window.location.hash) {
    let m = `${window.location.hash}`.match(/^#([A-Za-z0-9]+)-md$/)
    if (m.length > 1) return m[1]
  }

  return null
}

const getUrlID = () => {
  let id = getQueryParams()?.id

  if (id && !isNaN(id)) return parseInt(id)

  return null
}

const correctCategory = category => {
  switch ((category = `${category || ''}`.trim().toLowerCase())) {
    case 'dashboard':
    case 'message':
      return 'dashboard'
    case 'leader':
    case 'leaders':
      return 'leader'
    case 'division':
      return 'division'
    default:
      return null
  }
}

const MessagingEditor = () => {
  const urlCategory = getUrlCategory(),
    urlID = getUrlID()
  const { fetchAlert, fetchMessage, createMessage, Alert, updateAlert, isSaving } = Store
  const [category, setCategory] = useState(urlCategory || 'dashboard')
  const canCreate = ['dashboard', 'message', 'leader', 'leaders'].includes(category)

  const isEditing = () => {
    if (urlCategory) {
      if (Store.Message[urlCategory]) return Store.Message[urlCategory]?.isNew() || Store.Message[urlCategory]?.id() > 0
      return false
    }

    if (Store.Message[category]) return Store.Message[category]?.isNew() || Store.Message[category]?.id() > 0
    return false
  }

  const isActive = cat => {
    if (urlCategory) return urlCategory === cat
    return category === cat
  }

  const changeTab = cat => {
    if (!urlCategory && !isEditing()) setCategory(cat)
  }

  const renderTab = () => {
    const cat = correctCategory(category)

    if (isEditing()) return <MessageForm category={cat} />

    if (['dashboard', 'message', 'leader', 'leaders'].includes(cat)) return <MessagesList category={cat} />

    if (category === 'alerts') {
      return (
        <>
          <MDBRow>
            <MDBCol size='6'>
              <CustomAlert color='info'>
                <MDBRadio
                  disabled={isSaving}
                  onClick={() => (Alert.alert_type = 'info')}
                  checked={Alert?.alert_type === 'info' ? true : false}
                  label='Info Alert'
                  id='radio1'
                />
              </CustomAlert>
            </MDBCol>
            <MDBCol size='6'>
              <CustomAlert color='danger'>
                <MDBRadio
                  disabled={isSaving}
                  onClick={() => (Alert.alert_type = 'danger')}
                  checked={Alert?.alert_type === 'danger' ? true : false}
                  label='Danger Alert'
                  id='radio2'
                />
              </CustomAlert>
            </MDBCol>
            <MDBCol size='6'>
              <CustomAlert color='warning'>
                <MDBRadio
                  disabled={isSaving}
                  onClick={() => (Alert.alert_type = 'warning')}
                  checked={Alert?.alert_type === 'warning' ? true : false}
                  label='Warning Alert'
                  id='radio3'
                />
              </CustomAlert>
            </MDBCol>
            <MDBCol size='6'>
              <CustomAlert color='success'>
                <MDBRadio
                  disabled={isSaving}
                  onClick={() => (Alert.alert_type = 'success')}
                  checked={Alert?.alert_type === 'success' ? true : false}
                  label='Success Alert'
                  id='radio4'
                />
              </CustomAlert>
            </MDBCol>
          </MDBRow>
          <MDBRow>
            <MDBCol size='12'>
              <label>Active</label>
              <MDB4Switch
                disabled={isSaving}
                checked={parseInt(Alert?.active) === 1}
                onChange={() => (Alert.active = parseInt(Alert?.active) === 1 ? 0 : 1)}
              />
            </MDBCol>
          </MDBRow>
          <MDBRow>
            <MDBCol size='12'>
              <label className='d-block'>Content Goes Here</label>
              <TextEditor
                disabled={isSaving}
                id='messaging'
                value={Alert?.message}
                onChange={html => (Alert.message = html)}
              />

              <MDBBtn
                type='button'
                disabled={isSaving}
                color='indigo'
                onClick={() => {
                  try {
                    updateAlert()
                    toast.success('Saved alert.', {
                      position: toast.POSITION.TOP_RIGHT,
                    })
                  } catch (ex) {
                    toast.error(`${ex || 'Unable to save alert.'}`, {
                      position: toast.POSITION.TOP_RIGHT,
                    })
                  }
                }}
              >
                {isSaving ? 'Updating...' : 'Update'}
              </MDBBtn>
            </MDBCol>
          </MDBRow>
        </>
      )
    }
  }

  const renderTabs = () => {
    return (
      <ul className='nav nav-tabs md-tabs messaging-tabs' id='myTabMD' role='tablist'>
        <li className='nav-item waves-effect waves-light'>
          <MDBBtn
            type='button'
            color='default'
            disabled={isEditing()}
            className={`nav-link ${isActive('dashboard') ? 'active' : ''}`}
            onClick={event => changeTab('dashboard', event)}
          >
            {isActive('dashboard') ? <MDBIcon far icon='check-circle' /> : <MDBIcon far icon='circle' />}
            &nbsp; Message Board
          </MDBBtn>
        </li>
        <li className='nav-item waves-effect waves-light'>
          <MDBBtn
            type='button'
            color='default'
            disabled={isEditing()}
            className={`nav-link ${isActive('alerts') ? 'active' : ''}`}
            onClick={event => changeTab('alerts', event)}
          >
            {isActive('alerts') ? <MDBIcon far icon='check-circle' /> : <MDBIcon far icon='circle' />}
            &nbsp; Alerts
          </MDBBtn>
        </li>
        <li className='nav-item waves-effect waves-light'>
          <MDBBtn
            type='button'
            color='default'
            disabled={isEditing()}
            className={`nav-link ${isActive('leader') ? 'active' : ''}`}
            onClick={event => changeTab('leader', event)}
          >
            {isActive('leader') ? <MDBIcon far icon='check-circle' /> : <MDBIcon far icon='circle' />}
            &nbsp; Leader Messages
          </MDBBtn>
        </li>
        <li className='nav-item waves-effect waves-light'>
          {canCreate ? (
            <MDBBtn
              type='button'
              color='default'
              disabled={isEditing()}
              className={`nav-link new-msg-btn`}
              onClick={event => createMessage(category)}
            >
              Create Message&nbsp;
              <MDBIcon fas icon='plus-circle' />
            </MDBBtn>
          ) : (
            <></>
          )}
        </li>
      </ul>
    )
  }

  useEffect(() => {
    if (urlID) fetchMessage(urlID)
  }, [urlID])

  useEffect(() => {
    if (Alert === null) fetchAlert()
  }, [Alert])

  return (
    <section className='mx-2 pt-4' id='MessagingEditorComponent'>
      {renderTabs()}
      <div className='tab-content card pt-5'>{renderTab()}</div>
    </section>
  )
}

export default observer(MessagingEditor)
